import { LinkCard as RotaryMicrositeCardNPM } from '@rotaryintl/component-landing-pages';
import { Image, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { createLink } from '../../utilities/link-helpers';

const RotaryMicrositeCard = ({ fields: { IsFeatured, Link, Title, Description, Image: ImageField, Tag } = {} }) => (
  <RotaryMicrositeCardNPM
    colSpan={IsFeatured?.value === true ? '2' : '1'}
    tag={Tag?.fields?.Value?.value}
    link={createLink(Link, Title)}
    title={<Text field={Title} />}
    description={<RichText field={Description} />}
    image={ImageField?.value?.src && !ImageField?.value?.src.includes('default_image.svg') && <Image field={ImageField} />}
    backgroundColor="dark-blue"
  />
);

export default withSitecoreContext()(RotaryMicrositeCard);